// Moodles Scorm 1.2 API reference: /moodle/mod/scorm/datamodels/scorm_12.js
// This module overrides certain SCORM API functions to add custom behavior
// 1. such as redirecting to the dashboard when a module is passed and the user is on the last slide.
export default async () => {
  const LOG = (...a) => {
    if (localStorage.getItem('treadmaster_scormdebug') === 'true') {
      console.log('[Treadmaster SCORM:override] ', ...a);
    }
  };

  if (!document.querySelector('body.user-theme')) return;

  // If the SCORM module is rendererd inline, we don't override the next button behavior  
  if (document.querySelector('body.format-topics')) return;

  // ScormAPI orig functons
  let origScormApiInit = null;

  // WindowAPI orig functions and custom logic hooks
  // From observation only LMSCommit is reliably used when the module is running and ending
  // But we hook all functions for debugging purposes with non-tested scorm modules
  const hookTemplate = {
    orig: null,
    customLogic: null
  };
  let origWindowApiFunctions = {
    LMSInitialize: { ...hookTemplate },
    LMSGetValue: { ...hookTemplate },
    LMSSetValue: { ...hookTemplate },
    LMSCommit: {
      ...hookTemplate,
      customLogic: overrideNextButtonWhenModuleIsPassed
    },
    LMSFinish: { ...hookTemplate },
    LMSGetLastError: { ...hookTemplate },
    LMSGetErrorString: { ...hookTemplate },
    LMSGetDiagnostic: { ...hookTemplate }
  };

  try {
    // We have to wait for M.scorm_api to be initialized, as this is where Moodle sets up the SCORM API (via window.API)
    // ref: /moodle/mod/scorm/datamodels/scorm_12.js
    const scormApi = await waitForScormInit();

    // Save original init function
    origScormApiInit = scormApi.init;

    // Override M.scorm_api.init which will override window.API scorm functions
    scormApi.init = function (...args) {
      const returnValue = origScormApiInit.apply(this, args);

      // Now that M.scorm_api.init has run, we can override window.API functions
      // window.API is the SCORM 1.2 API object
      overrideWindowAPI(window.API);

      return returnValue;
    };

    // Fallback override in case M.scorm_api.init already ran before our override
    overrideWindowAPI(window.API);

    LOG('M.scorm_api.init override done');
  } catch (err) {
    console.warn('[Treadmaster SCORM]', err.message);
  }

  // Wait for M.scorm_api to be initialized
  function waitForScormInit({ interval = 50, timeout = 20000 } = {}) {
    return new Promise((resolve, reject) => {
      const start = Date.now();

      const timer = setInterval(() => {
        if (window.M && M.scorm_api && typeof M.scorm_api.init === 'function') {
          clearInterval(timer);
          resolve(M.scorm_api);
          return;
        }

        if (Date.now() - start > timeout) {
          clearInterval(timer);
          reject(new Error('Timed out waiting for M.scorm_api.init'));
        }
      }, interval);
    });
  }

  // Override window.API functions
  function overrideWindowAPI(api) {
    if (!api) return;

    function overrideFunction(fnName, customLogic = null) {
      if (typeof api[fnName] !== 'function') return;

      const original = api[fnName];

      LOG(`overriding window.API.${fnName}`);

      api[fnName] = function (...args) {
        const returnValue = original.apply(this, args);

        LOG(`${fnName}`, { args: JSON.stringify(args), returnValue });
        // console.log(`[Treadmaster SCORM 1.2] ${fnName}`, {
        //   ...args,
        //   returnValue
        // });

        customLogic && customLogic.apply();

        return returnValue;
      };

      return original;
    }

    Object.keys(origWindowApiFunctions).forEach((fnName) => {
      origWindowApiFunctions[fnName].orig = overrideFunction(
        fnName,
        origWindowApiFunctions[fnName].customLogic
      );
    });

    LOG('window.API overrides done');
  }

  // Handler function to link to dashboard when module is passed and on last slide
  function linkToDashboard() {
    LOG({
      isModulePassed: isModulePassed(),
      isOnLastSlide: isOnLastSlide()
    });
    if (isModulePassed() && isOnLastSlide()) {
      window.location.href = M.cfg.wwwroot + '/my/';
    }
  }

  // Check if we are on the last slide of the SCORM module
  function isOnLastSlide() {
    const lastSlide = document
      .querySelector('iframe#scorm_object')
      .contentWindow.document.querySelector(
        'nav#outline-content li:last-child > div.cs-listitem'
      );
    return lastSlide?.classList.contains('cs-selected');
  }

  // Check if the SCORM module is marked as passed
  function isModulePassed() {
    return window.API.LMSGetValue('cmi.core.lesson_status') === 'passed';
  }

  // Override Next button behavior when module is passed
  function overrideNextButtonWhenModuleIsPassed() {
    // If the SCORM module is rendererd inline, we don't override the next button behavior
    // if (document.querySelector('body#page-mod-scorm-player.format-topics'))
    //   return;

    const nextButton = document
      .querySelector('iframe#scorm_object')
      .contentWindow.document.querySelector(' nav#nav-controls #next');

    LOG({
      isModulePassed: isModulePassed(),
      isOnLastSlide: isOnLastSlide()
    });

    if (isModulePassed() && isOnLastSlide()) {
      nextButton?.classList.remove('cs-disabled');

      nextButton.removeEventListener('click', linkToDashboard);
      nextButton.addEventListener('click', linkToDashboard);
    }
  }
};
